import { TicketItem } from '../models/domain/ticket.item';
import { TicketTotals } from '../models/domain/ticket.totals';
import { TicketGlobals } from '../models/domain/ticket.globals';
import { TicketDepartmentArray } from '../models/domain/ticket.department';
import { TicketStatusArray } from '../models/domain/ticket.status';
import { TicketWidgetItem, TicketWidgetItemArray } from '../models/domain/ticket.widget.item';
import { TicketsCountItemArray } from '../models/domain/ticket.count.item';
import { Subscription } from 'rxjs';
import { Injectable, OnDestroy } from '@angular/core';

import { ssApiService } from './ss-api.service';
import { GlobalService } from './global.service';
import { Subject } from 'rxjs';
import { TicketAssignAdminRequest } from '../models/ss-api/requests/ticket.assign.admin.request';

@Injectable()
export class TicketService implements OnDestroy {

    public Busy: boolean = false;

    public LastDraggedUnclaimedWidget: TicketWidgetItem;

    public onTicketGlobalsChanged = new Subject<TicketGlobals>();
    public onUnclaimedTicketsChanged = new Subject<TicketWidgetItemArray>();
    public onMemberTicketsChanged = new Subject<TicketWidgetItemArray>();
    public onMemberAssignedChanged = new Subject<TicketWidgetItem>();
    public onMemberUnassignedChanged = new Subject<TicketWidgetItem>();
    public onAdminAssignedChanged = new Subject<TicketWidgetItem>();
    public onBusyChanged = new Subject<boolean>();
    public onMyTotalsChanged = new Subject<TicketTotals>();
    public onDepartmentsChanged = new Subject<TicketDepartmentArray>();
    public onStatusesChanged = new Subject<TicketStatusArray>();
    public onTicketOpened = new Subject<TicketWidgetItem>();
    public onTicketReply = new Subject<TicketWidgetItem>();
    public onTicketNewTicket = new Subject<TicketItem>();


    //
    private myTotals = new TicketTotals();
    private totals = new TicketsCountItemArray();
    private ticketsWidgetsOwn = new TicketWidgetItemArray();
    private ticketsWidgetsUnclaimed = new TicketWidgetItemArray();
    private ticketsWidgetsMember = new TicketWidgetItemArray();
    private ticketStatuses = new TicketStatusArray();
    private ticketDepartments = new TicketDepartmentArray();
    private ticketGlobals = new TicketGlobals();

    // sdb2 subscriptions
    private ssdbTicketGlobals: Subscription;
    private ssdbTicketAssignedToMember: Subscription;
    private ssdbTicketAssignedToAdmin: Subscription;
    private ssdbTicketMyTotals: Subscription;
    private ssdbTicketDepartments: Subscription;
    private ssdbTicketStatuses: Subscription;
    private ssdbTicketOpenNew: Subscription;

    // live
    private liveTicketAssignToAdmin: Subscription;
    private liveTicketUnassignedFromMember: Subscription;
    private liveTicketAssignedToMember: Subscription;
    private liveTicketOpened: Subscription;
    private liveTicketReply: Subscription;


    constructor(private ssdb2: ssApiService, private gb: GlobalService) {
        //disabled constructer methods - ticket service is deprecated in favor of custom ticketing
        /*
        this.RefreshStatusesAndDepartments();
        this.SubcribeToEvents();
        this.RefreshOwn();
        */
    }

    SubcribeToEvents() {
        this.ssdbTicketGlobals = this.ssdb2.onTicketGlobals.subscribe(
            (response) => {
                let data = response.Data;
                this.ticketGlobals = data;
                this.ticketsWidgetsOwn = data.Widgets;
                this.myTotals = data.Totals;

                this.onTicketGlobalsChanged.next(data);
                this.onMyTotalsChanged.next(data.Totals);
            }
        )

        this.ssdbTicketStatuses = this.ssdb2.onTicketStatuses.subscribe(
            (response) => {
                let data = response.Data;
                this.ticketStatuses = data;
                this.onStatusesChanged.next(data);
            }
        )

        this.ssdbTicketDepartments = this.ssdb2.onTicketDepartments.subscribe(
            (response) => {
                let data = response.Data;
                this.ticketDepartments = data;
                this.onDepartmentsChanged.next(data);
            }
        )

        this.ssdbTicketMyTotals = this.ssdb2.onTicketAdminTotals.subscribe(
            (response) => {
                let data = response.Data;
                this.myTotals = data;
                this.onMyTotalsChanged.next(data);
            }
        )

        this.ssdbTicketOpenNew = this.ssdb2.onTicketOpenNew.subscribe(
            (response) => {
                let data = response.Data;

                let widget = this.TicketItemToWidget(data);

                if (data.AdminID == this.gb.AdminId) {
                    // is own ticket
                    // this.ticketsWidgetsOwn.push(widget);
                    this.ssdb2.getTicketMyTotals(this.gb.AdminId).subscribe();
                    this.onUnclaimedTicketsChanged.next(this.ticketsWidgetsUnclaimed);
                } else if (data.MemberID > 0) {
                    // is member ticket
                    this.ticketsWidgetsMember.push(widget);
                    this.onMemberAssignedChanged.next(widget);
                } else {
                    // unclaimed
                    this.ticketsWidgetsUnclaimed.push(widget);
                }

            }

        )

    }

    ngOnDestroy() {
        this.liveTicketAssignToAdmin.unsubscribe();
        this.ssdbTicketGlobals.unsubscribe();
        this.ssdbTicketAssignedToAdmin.unsubscribe();
        this.ssdbTicketAssignedToMember.unsubscribe();
        this.ssdbTicketMyTotals.unsubscribe();
        this.ssdbTicketDepartments.unsubscribe();
        this.ssdbTicketStatuses.unsubscribe();
        this.liveTicketUnassignedFromMember.unsubscribe();
        this.ssdbTicketOpenNew.unsubscribe();
    }

    private TicketItemToWidget(ticket: TicketItem): TicketWidgetItem {

        let widget = new TicketWidgetItem();

        widget.AdminID = ticket.AdminID;
        widget.Email = ticket.Email;
        widget.MemberID = ticket.MemberID;
        widget.Name = ticket.Name;
        widget.Priority = ticket.Priority;
        widget.Status = ticket.Status;
        widget.Subject = ticket.Subject;
        widget.TicketID = ticket.TicketID;
        widget.TicketNR = ticket.TicketNR;

        return widget;

    }


    private TicketsTotalArrayToCount(data: TicketsCountItemArray): number {
        let total = 0;

        data.forEach(item => {
            total += item.Total;
        })

        return total;
    }

    RefreshStatusesAndDepartments() {
        // this.ssdb2.GetTicketDepartments().subscribe();
        this.ssdb2.getTicketStatuses().subscribe();
    }

    RefreshOwn() {
        this.ssdb2.GetTicketGlobals(this.gb.AdminId, false).subscribe();
    }

    RefreshUnclaimed() {
        // we do this here because if we make a global subscription we don't know if the tickets are own or from somebody else
        let subscr = this.ssdb2.GetTicketsWidgetsData(0, false, true).subscribe((data) => {
            subscr.unsubscribe();
            this.ticketsWidgetsUnclaimed = data.Data;
            this.onUnclaimedTicketsChanged.next(data.Data);
        })
    }

    RefreshMember(memberID: number, includeClosed: boolean = false) {
        //
        let subscr = this.ssdb2.GetTicketsMemberWidgetsData(memberID, includeClosed).subscribe((data) => {
            subscr.unsubscribe();
            this.ticketsWidgetsMember = data.Data;
            this.onMemberTicketsChanged.next(data.Data);
        })
    }

    public NotAssignedTotals(): number {

        let total = 0;

        this.totals.forEach(item => {
            if (item.AdminID == 0 && item.Status.toLowerCase() != 'closed')
                total += item.Total;
        })

        return total;
    }

    public WidgetsOwn(): TicketWidgetItemArray {
        return this.ticketsWidgetsOwn;
    }

    public TicketAssignedToMember(ticketId: number, memberId: number, memberName: string) {

        let widgetOwn = this.ticketsWidgetsOwn.find(x => x.TicketID == ticketId);
        if (widgetOwn != undefined) {
            widgetOwn.MemberID = memberId;
            widgetOwn.Name = memberName;
            this.onMemberAssignedChanged.next(widgetOwn);
            this.ticketsWidgetsMember.push(widgetOwn);
        }

        let widgetUnclaimed = this.ticketsWidgetsUnclaimed.find(x => x.TicketID == ticketId);
        if (widgetUnclaimed != undefined) {
            widgetUnclaimed.MemberID = memberId;
            widgetUnclaimed.Name = memberName;
            this.onMemberAssignedChanged.next(widgetUnclaimed);
            this.ticketsWidgetsMember.push(widgetUnclaimed);
        }


    }

    public WidgetsUnclaimed(): TicketWidgetItemArray {
        return this.ticketsWidgetsUnclaimed;
    }

    private SetBusy(value: boolean) {
        this.Busy = value;
        this.onBusyChanged.next(value);
    }

    public async AssignDraggedToAdmin() {
        if (this.LastDraggedUnclaimedWidget == null)
            return false;

        this.SetBusy(true);

        let request = new TicketAssignAdminRequest();
        request.AdminID = this.gb.AdminId;
        request.TicketID = this.LastDraggedUnclaimedWidget.TicketID;

        await this.ssdb2.TicketAssignAdmin(request)
            .toPromise()
            .then(async (data) => {
                if (data.Result) {

                    this.ticketsWidgetsOwn.push(this.LastDraggedUnclaimedWidget);

                    await this.ssdb2.getTicketMyTotals(this.gb.AdminId).toPromise()
                        .then((data) => {
                        });

                    this.onAdminAssignedChanged.next(this.LastDraggedUnclaimedWidget);
                }

                this.SetBusy(false);
                return data;
            })
            .catch((error) => {
                this.SetBusy(false);
            })


    }




    public MyClaimedTickets(): number {
        return this.myTotals.MyTickets;
    }


    public UnClaimedTickets(): number {
        return this.myTotals.UnclaimedTickets;
    }

    public MyTotals(): number {

        let total = 0;

        this.totals.forEach(item => {
            if (item.AdminID == this.gb.AdminId && item.Status.toLowerCase() != 'closed')
                total += item.Total;
        })

        return total;
    }

    public MyClosedTotals(): number {

        let total = 0;

        this.totals.forEach(item => {
            if (item.AdminID == this.gb.AdminId && item.Status.toLowerCase() == 'closed')
                total += item.Total;
        })

        return total;
    }

    public UnclaimedTotals(): number {

        let total = 0;

        this.totals.forEach(item => {
            if (item.AdminID == 0 && item.Status.toLowerCase() != 'closed')
                total += item.Total;
        })

        return total;
    }

    public OthersTotals(): number {

        let total = 0;

        this.totals.forEach(item => {
            if (item.AdminID != this.gb.AdminId && item.AdminID != 0 && item.Status.toLowerCase() != 'closed')
                total += item.Total;
        })

        return total;
    }

    public OthersClosedTotals(): number {

        let total = 0;

        this.totals.forEach(item => {
            if (item.AdminID != this.gb.AdminId && item.Status.toLowerCase() == 'closed')
                total += item.Total;
        })

        return total;
    }

    public TotalsList(): TicketsCountItemArray {
        return this.totals;
    }

    public GetStatusColor(status: string): string {
        let item = this.ticketStatuses.find(x => x.Status == status);
        return item.Color;
    }

    public RemoveFromUnclaimedByID(ticketID: number) {
        let index = this.ticketsWidgetsUnclaimed.findIndex(x => x.TicketID == ticketID);
        this.ticketsWidgetsUnclaimed.splice(index, 1);
    }

    public RemoveFromMemberByID(ticketID: number) {
        let index = this.ticketsWidgetsMember.findIndex(x => x.TicketID == ticketID);
        this.ticketsWidgetsMember.splice(index, 1);
    }

    public Departments(): TicketDepartmentArray {
        return this.ticketDepartments;
    }

    public Statuses(): TicketStatusArray {
        return this.ticketStatuses;
    }


}
